// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2F0DJ","head":"Table_head__1I5LK","col":"Table_col__CTUbq"};